var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19004 0C3.66212 0 0 3.443 0 7.7C0 13.475 8.19004 22 8.19004 22C8.19004 22 16.3801 13.475 16.3801 7.7C16.3801 3.443 12.718 0 8.19004 0ZM8.19004 10.45C6.57543 10.45 5.26503 9.218 5.26503 7.7C5.26503 6.182 6.57543 4.95 8.19004 4.95C9.80465 4.95 11.1151 6.182 11.1151 7.7C11.1151 9.218 9.80465 10.45 8.19004 10.45Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.10e5386caa53b904e62663464fd15ea4.svg";
export { ForwardRef as ReactComponent };